import React, { Component } from 'react';
import { Form, Input, Button, Icon, message } from 'antd';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { apis } from '../api/index.js';
import './login.css';
import { Translation } from 'react-i18next';
import { LoginUserIcon, LoginPassIcon } from '../../src/utils/svg';
import { aesMinEncrypt } from '../utils';
import { LoginTimeIcon } from '../../src/utils/svg';
// LoginUserIcon
class LoginFrom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accountName: '',
      password: '',
      tips: '',
      imgCodeUrl: '/ai-web/boxuser/verifyCodeGen',
      btnDisabled: true,
      userCount: 0,
      dcmCount: 0,
      loginType: 'account',
      sendEmailButtonDisabled: false,
      email: '',
      fromExe: false,
    };
  }

  static propTypes = {
    user: PropTypes.object,
    history: PropTypes.object,
    forgetPasswordVisible: PropTypes.func.isRequired,
    handleLoginResult: PropTypes.func.isRequired,
    setLoginType: PropTypes.func.isRequired,
    form: PropTypes.object,
  };

  componentDidMount() {}

  handleSubmit = (t, e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) this.login(values, t);
    });
  };

  login = values => {
    let { username, password, code } = values;
    password = aesMinEncrypt(password);
    let post = { accountName: username, password, verifyCode: code };

    apis.login(post).then(result => {
      if (result.code === '0') {
        result.data.accountName = values.username;
        result.data.password = values.password;
        this.props.handleLoginResult(result);
      } else {
        message.error(result.message);
      }
    });
  };

  handleregister = () => {
    this.props.history.push('/register');
  };

  setLoginType = type => {
    this.props.setLoginType(type);
  };

  forgetPasswordVisible = state => {
    this.props.forgetPasswordVisible(state);
  };
  downloadExe = () => {
    window.location.href = `https://production.jfhealthcare.cn/ai-web/upgrade/JfaiClient.zip`;
  };

  sendVCodeToEmail = e => {
    e.preventDefault();
    const values = this.props.form.getFieldsValue(['username', 'password']);
    let { username, password } = values;
    if (password) password = aesMinEncrypt(password);
    if (username && password) {
      const post = { accountName: username, password };
      apis.sendVCodeToEmailUseAcc(post).then(res => {
        if (res.code === '0') message.success('验证码发送成功');
        else message.error(res.message);
      });
    } else message.warning('请输入用户名和密码');
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const inputStyle = { color: 'rgba(0,0,0,.25)', fontSize: '18px' };
    return (
      <Translation>
        {t => (
          <div className="login-form-box">
            <p className="form-tit">
              <span>帐号密码登录</span>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <Button
                type="link"
                className="login-by-email"
                onClick={this.setLoginType.bind(this, 'email')}
              >
                邮箱快捷登录&gt;
              </Button>
            </p>
            <Form
              onSubmit={this.handleSubmit.bind(this, t)}
              className="login-form"
            >
              <Form.Item>
                {getFieldDecorator('username', {
                  rules: [{ required: true, message: '请输入账号' }],
                })(
                  <div className="loginIconBox">
                    <span className="loginIcon">
                      <LoginUserIcon />
                    </span>
                    <Input
                      placeholder="账号"
                      style={inputStyle}
                      className="login-input"
                    />
                  </div>
                )}
              </Form.Item>
              <Form.Item>
                {getFieldDecorator('password', {
                  rules: [{ required: true, message: t('passwordTip') }],
                })(
                  <div className="loginIconBox">
                    <span className="loginIcon">
                      <LoginPassIcon />
                    </span>
                    <Input.Password
                      placeholder={t('password')}
                      style={inputStyle}
                      className="login-input"
                    />
                  </div>
                )}
              </Form.Item>
              <Form.Item style={{ display: 'inline-block' }}>
                {getFieldDecorator('code', {})(
                  <div className="loginIconBox" style={{ width: '200px' }}>
                    <span className="loginIcon">
                      <LoginTimeIcon />
                    </span>
                    <Input
                      placeholder={t('verifyCode')}
                      style={inputStyle}
                      className="login-input"
                    />
                  </div>
                )}
              </Form.Item>
              <Button
                className="img-button email-send-button"
                type="primary"
                // disabled={this.state.sendEmailButtonDisabled}
                onClick={this.sendVCodeToEmail}
              >
                发送验证码
              </Button>
              <div className="forget-pwd-link">
                <Button
                  type="link"
                  onClick={this.forgetPasswordVisible.bind(this, true)}
                >
                  忘记密码？
                </Button>
              </div>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="login-form-button"
                  size="large"
                  block
                  // disabled={hasErrors(getFieldsError())}
                >
                  {t('login')}
                </Button>
                <p className="to-register from-login">
                  没有账号？
                  <Button type="link" onClick={this.handleregister}>
                    点击注册
                  </Button>
                  <Button
                    type="link"
                    className="download-exe"
                    onClick={this.downloadExe}
                  >
                    <Icon
                      type="vertical-align-bottom"
                      style={{
                        fontSize: '16px',
                        position: 'relative',
                        right: '-8px',
                        top: '1px',
                        color: '#0f80ff',
                      }}
                    />
                    下载客户端
                  </Button>
                </p>
              </Form.Item>
            </Form>
          </div>
        )}
      </Translation>
    );
  }
}

export default withRouter(Form.create()(LoginFrom));
